<template>
    <div class="search-container" :class="[customClass, { 'search-auditor': isAuditor }, { 'with-qr': showQrIcon }, { 'has-search': showQrIcon && search !== '' }, $mq]">
        <input type="search" :value="search" @input="handleInput" class="search" :placeholder="placeholder" autofocus @focus="handleFocus" @blur="handleBlur" />
        <button v-if="showQrIcon" type="button" class="qr" aria-label="Escanear código QR" @click="handleQrClick"></button>
        <button v-if="search != ''" class="close" @click="handleCloseButton"></button>
    </div>
</template>

<script>
export default {
    name: 'SearchBar',
    props: {
        search: String,
        customClass: {
            type: String,
            default: ''
        },
        placeholder: {
            type: String,
            default: ''
        },
        isAuditor: {
            type: Boolean,
            default: false
        },
        showQrIcon: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        handleQrClick() {
            this.$emit('on-qr-click')
        },
        handleInput(e) {
            this.$emit('on-search', e)
        },
        handleCloseButton() {
            this.$emit('on-button-click')
        },
        handleFocus(e) {
            e.preventDefault()
            e.stopPropagation()
            this.$emit('on-focus')
        },
        handleBlur() {
            this.$emit('on-blur')
        }
    }
}
</script>

<style lang="scss" scoped>
input[type='search']::-webkit-search-decoration,
input[type='search']::-webkit-search-cancel-button,
input[type='search']::-webkit-search-results-button,
input[type='search']::-webkit-search-results-decoration {
    display: none;
}

input[type='search'] {
    margin: 0px;
}

input[type='search']::placeholder {
    @include font-size(ml);
    font-family: $text;
}
#content.audit .search-container {
    margin: 0px !important;
    width: 100% !important;
    height: 45px !important;
    .search {
        height: 35px !important;
        background-size: 24px !important;
    }

    .close {
        @media (max-width: 1023px) {
            width: 24px !important;
            height: 24px !important;
            right: 8px !important;
        }
    }
}
.search-container {
    position: relative;
    width: 100%;
    margin: 0;
    padding-bottom: 12px;

    &.with-qr {
        display: flex;
        padding: 8px;
        justify-content: space-between;
        align-items: center;
        border-radius: 4px;
        background: var(--color-white, #fff);
        box-sizing: border-box;

        .search {
            flex: 1;
            min-width: 0;
            padding-left: 45px;
            padding-right: 12px;
            height: 29px;
        }

        &.has-search .search {
            padding-right: 52px;
        }
    }

    &.portrait {
        input[type='search'] {
            @include font-size(s);
        }

        input[type='search']::placeholder {
            @include font-size(s);
            font-family: $text;
        }
    }
    &.multiSelector-popup {
        .search {
            height: 40px;
            display: flex;
            padding: 8px;
            align-items: center;
            gap: 8px;
            align-self: stretch;
            border: 1px solid $color-neutral-300;
            @include border-radius(4px);
        }

        .close {
            display: none;
        }
    }
    &.selector-popup {
        padding-bottom: 0;
        border: 1px solid $color-neutral-300;
        @include border-radius(4px);
        height: 40px !important;
        .search {
            height: 35px !important;
        }
        .close {
            display: none;
        }
    }

    &.search-bar-audit {
        &.desktop {
            margin-bottom: 0px !important;
        }

        &.portrait {
            margin-bottom: 0px !important;
        }
    }

    .search {
        @include display-flex();
        @include align-items(center);
        @include background($image: img('search_neutro.svg'), $size: 25px, $position: left 12px center);
        @include border-radius(4px);
        @include font-size(ml);
        height: 45px;
        width: 100%;
        background-color: #fff;
        padding: 0 60px 0 45px;
        border-bottom: none;
        font-family: $text;
        cursor: text;
    }

    .qr {
        display: flex;
        width: 20px;
        height: 20px;
        justify-content: center;
        align-items: center;
        flex-shrink: 0;
        aspect-ratio: 1 / 1;
        background-color: transparent;
        cursor: pointer;
        padding: 0;
        border: none;
        @include border-radius(0);
        order: 2;

        &::before {
            font-family: 'andy-icons';
            content: '\e9c4';
            font-size: 20px;
            color: $neutro-text;
        }
    }

    .close {
        @include border-radius(4px);
        @include background($image: img('close_dark.svg'), $size: 12px, $position: center center);
        width: 33px;
        height: 33px;
        position: absolute;
        top: 7px;
        right: 10px;
        background-color: $neutro-t50;
        cursor: pointer;
        order: 1;
    }

    &.with-qr.has-search .close {
        position: static;
        width: 20px;
        height: 20px;
        background-color: transparent;
        flex-shrink: 0;
    }
}
</style>
